import script from "./AjudaBotao.vue?vue&type=script&setup=true&lang=js"
export * from "./AjudaBotao.vue?vue&type=script&setup=true&lang=js"

import "./AjudaBotao.vue?vue&type=style&index=0&id=ba8eb23a&lang=css"

const __exports__ = script;

export default __exports__